import PropTypes from 'prop-types';

import React from 'react';
import { List } from 'immutable';

import DashedLine from '../DashedLine';
import EditorAddItem from '../EditorAddItem';
import Section from './Section';
import AddListWrapper from './AddListWrapper';
import AddList from './AddList';
import AddButton from './AddButton';

function EditorAdd(props) {
  return (
    <Section onMouseLeave={props.onClose}>
      <AddButton
        type="button"
        active={props.isOpen}
        onMouseEnter={props.onOpen}
      >
        <span style={{ display: 'flex', justifyContent: 'center' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
            <path fill="currentColor" d="M2.564 0h18.872c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54v18.873c0 .892-.093 1.215-.267 1.54a1.81 1.81 0 0 1-.756.757c-.326.174-.65.267-1.54.267H2.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 0 1-.757-.756C.093 22.65 0 22.327 0 21.437V2.563c0-.892.093-1.215.267-1.54a1.81 1.81 0 0 1 .756-.757C1.35.093 1.673 0 2.563 0z" />
            <path fill="#3D3234" d="M17.6 10.6h-4.2V6.4c0-.7-.7-1.4-1.4-1.4s-1.4.7-1.4 1.4v4.2H6.4c-.7 0-1.4.7-1.4 1.4s.7 1.4 1.4 1.4h4.2v4.2c0 .7.7 1.4 1.4 1.4s1.4-.7 1.4-1.4v-4.2h4.2c.7 0 1.4-.7 1.4-1.4s-.56-1.4-1.4-1.4z" />
          </svg>
        </span>
      </AddButton>

      {props.isOpen && (
        <AddListWrapper>
          <DashedLine style={{ position: 'absolute', top: 0 }} />

          <AddList>
            {props.items.map(item => (
              <EditorAddItem
                key={item.id}
                {...item}
                index={props.index}
                onItemClick={props.onCreateBlock}
              />
            ))}
          </AddList>
        </AddListWrapper>
      )}
    </Section>
  );
}

EditorAdd.propTypes = {
  items: PropTypes.instanceOf(List).isRequired,
  isOpen: PropTypes.bool,
  index: PropTypes.number,

  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onCreateBlock: PropTypes.func,
};

export default EditorAdd;
